<h1 class="accessibility-only">Badges</h1>
<ng-container *notInPopulation="[populations.JuniorBluebirds]">
  <div class="d-lg-block d-none">
    <fgb-banner [title]="'home.page.challenges' | translate"></fgb-banner>
  </div>
  <div class="d-lg-none">
    <fgb-mobile-page-header
      pageTitle="challenges.page.title"
      [showFooter]="true"
      [showQr]="true"
      [backButtonLink]="'/'"
    ></fgb-mobile-page-header>
  </div>
</ng-container>
<ng-container *inPopulation="[populations.JuniorBluebirds]">
  <fgb-banner
    [isImageBanner]="true"
    [imageBannerUrl]="'banners/kids-challenges-banner.jpg'"
    class="d-lg-flex d-none"
  ></fgb-banner>
  <div class="d-block d-lg-none">
    <fgb-mobile-page-header
      pageTitle="rewards.page.title"
      [showFooter]="true"
      [showQr]="true"
      [backButtonLink]="'/'"
      [isImageBanner]="true"
      [imageBannerUrl]="'banners/kids-challenges-banner.jpg'"
    ></fgb-mobile-page-header>
  </div>
</ng-container>

<div class="container mt-lg-4">
  <fgbcl-badge-achieved></fgbcl-badge-achieved>
</div>

<div class="challenges-list-div">
  <fgbcl-scorecard-list-view
    [icon]="'chevron_right'"
    [showPlaceholder]="true"
    [ngClass]="isCorporate ? 'corporate' : 'membership'"
  ></fgbcl-scorecard-list-view>
</div>
